<template>
  <div
    class="picker" @touchstart="touchstart" @touchmove="touchmove" @touchend="touchend">
    <div class="picker-mask linear" />
    <div class="picker-indicator" />
    <div class="picker-content" ref="picker">
      <div v-for="(item, i) in data" :key="i" class="picker-item" :style="pickerStyle(i)">
        <p>{{ item.text }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import mixins from '@/utils/mixins'
export default {
  mixins: [mixins],
  props: {
    selectedIndex: {
      type: Number,
      default: -1
    },
    data: {
      type: Array,
      default: () => [{
        text: '', value: ''
      }]
    }
  },
  data () {
    return {
      startY: 0,
      distance: 0,
      activeIndex: 3,
      itemHeight: 28
    }
  },
  watch: {
    selectedIndex (newValue) {
      this.initMove()
    }
  },
  mounted () {
    this.itemHeight = this.pxGo(this.itemHeight)
    this.initMove()
  },
  methods: {
    pickerStyle (index) {
      let deg = 0
      const tmp = this.activeIndex - index
      if (tmp >= -1 && tmp <= 1) {
        deg = (this.activeIndex - index) * 20
      } else {
        // 为了让数值变化不变形
        deg = 0
      }
      return {
        transform: `rotateX(${deg}deg)`
      }
    },
    touchstart (e) {
      e.preventDefault()
      const target = e.changedTouches ? e.changedTouches[0] : e
      this.startY = target.clientY
      this.startTime = new Date().getTime()
    },
    touchmove (e) {
      const target = e.changedTouches ? e.changedTouches[0] : e
      const currentY = target.clientY
      const moveY = parseInt(currentY - this.startY)
      let scrollTop = this.distance + moveY
      if (scrollTop > this.itemHeight * 3) {
        // 超过最大值处理
        scrollTop = this.itemHeight * 3
      }
      const min = this.itemHeight * 4 - this.data.length * this.itemHeight
      if (scrollTop < min) {
        // 低于最小值处理
        scrollTop = min
      }
      this.move(scrollTop)
    },
    touchend (e) {
      const target = e.changedTouches ? e.changedTouches[0] : e
      const currentY = target.clientY
      let moveY = parseInt(currentY - this.startY)
      const endTime = new Date().getTime()
      if (endTime - this.startTime < 200) {
        // 快速滑动时距离翻5倍
        moveY = moveY * 5
      }
      const moveYL = moveY % this.itemHeight
      // 取itemHeight的整数倍，四舍五入
      moveY = moveY - moveYL
      if (moveYL >= this.itemHeight / 2) {
        moveY += this.itemHeight
      } else if (moveYL <= -this.itemHeight / 2) {
        moveY -= this.itemHeight
      }
      this.distance = this.distance + moveY
      if (this.distance > this.itemHeight * 3) {
        // 超过最大值处理
        this.distance = this.itemHeight * 3
      }
      const min = this.itemHeight * 4 - this.data.length * this.itemHeight
      if (this.distance < min) {
        // 低于最小值处理
        this.distance = min
      }
      this.move(this.distance)
      this.countListIndex(this.distance)
      this.$emit('onChange', {
        index: this.activeIndex,
        text: this.data[this.activeIndex] && this.data[this.activeIndex].text,
        value: this.data[this.activeIndex] && this.data[this.activeIndex].value
      })
    },
    move (top) {
      // 滑动动画
      const picker = this.$refs.picker
      if (!picker) return
      picker.style.transform = `translate3d(0, ${top}px, 0)`
    },
    countListIndex (pageY) {
      // 计算滑动之后所在的索引
      let n = Math.round(pageY / this.itemHeight)
      n = n > 0 ? 3 - n : Math.abs(n) + 3
      this.activeIndex = Math.round(n)
    },
    initMove () {
      this.distance = 0
      if (this.selectedIndex > 2) {
        this.distance = (3 - this.selectedIndex) * this.itemHeight
      } else {
        this.distance = (3 - this.selectedIndex) * this.itemHeight
      }
      setTimeout(() => {
        this.move(this.distance)
      }, 0)
    }
  }
}
</script>

<style lang="scss" scoped>
.picker {
  position: relative;
  height: 196px;
  overflow: hidden;
  .picker-content {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
    width: 100%;
    .picker-item {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      height: 28px;
      p {
        color: $color-bg-black;
        font-size: $h5-font-size;
        line-height: $h5-font-size;
        text-align: center;
      }
    }
  }
  .picker-mask {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 3;
    width: 100%;
    height: 100%;
    transform: translateZ(0);
  }
  .picker-indicator {
    position: absolute;
    top: 84px;
    left: 0;
    z-index: 3;
    width: 100%;
    height: 28px;
    @include border-horizontal;
  }
}
</style>
